module.exports = __webpack_public_path__ + "static/media/arcad-game.966aefee.png";